<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'

import EventCalendar from 'components/EventCalendar'

export default {
  name: 'venue-app-events',
  components: {
    EventCalendar,
  },
  data() {
    return {
      prevRoute: null,
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  computed: {
    ...mapState({
      venue: (state) => state.venue.current,
    }),
  },
  methods: {
    goBack() {
      this.$router.push({
        name: !this.prevRoute || !this.prevRoute.name || this.prevRoute.name === 'VenueApp' ? 'VenueAppHome' : this.prevRoute.name,
        query: this.$route.query,
        params: this.prevRoute ? this.prevRoute.params : null,
      })
    },
    onEventClicked(event) {
      this.$router.push({
        name: 'VenueAppEvent',
        params: {
          venueId: this.venue.slug,
          eventId: event.id,
        },
      })
    },
  },
  metaInfo() {
    const pageTitle = `Events at ${this.venue.name} | Powered by TablelistPro`
    const pageDescription = ''

    return {
      title: pageTitle,
      meta: [
        {
          property: 'og:title',
          content: pageTitle,
        },
        {
          property: 'og:description',
          content: pageDescription,
        },
      ],
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Venue/VenueAppEvents/index.vue